module.exports = __webpack_public_path__ + "static/media/warning-outline.f566ad86.svg";